module.exports = __webpack_public_path__ + "img/uppdrag-dashboard.0f17a39e.jpg";